import { MutableEntity } from '../../common';
import type { CommandContext } from '../../common/context';
import type { ImportTableDefinitionRevision } from '../importTableDefinitionRevision';
import type { ImportTableDefinition } from './index';

export type ResolveRevisionPointersAfterCreateParams = {
  definition: ImportTableDefinition;
  newRevisionId: ImportTableDefinitionRevision.Id;
};

/**
 * 新 revision 作成後の `lastRevisionId` / `activeRevisionId` を決定する。
 *
 * `activeRevisionId` は明示的な activate のみで更新する（新 revision 作成では据え置き）。
 */
export const resolveRevisionPointersAfterCreate = (
  params: ResolveRevisionPointersAfterCreateParams,
): Pick<ImportTableDefinition, 'lastRevisionId' | 'activeRevisionId'> => {
  const { definition, newRevisionId } = params;

  return {
    lastRevisionId: newRevisionId,
    activeRevisionId: definition.activeRevisionId,
  };
};

export type AdvanceRevisionPointersParams = {
  current: ImportTableDefinition;
  newRevisionId: ImportTableDefinitionRevision.Id;
  context: CommandContext;
};

/**
 * 新 revision 作成に伴う `ImportTableDefinition` のポインタ更新を一度に行う。
 *
 * - `resolveRevisionPointersAfterCreate` で次の `lastRevisionId` / `activeRevisionId` を決定
 * - `MutableEntity.Update` で `updatedAt` / `updatedBy` を進める
 */
export const advanceRevisionPointers = (params: AdvanceRevisionPointersParams): ImportTableDefinition => {
  const { current, newRevisionId, context } = params;
  const pointers = resolveRevisionPointersAfterCreate({
    definition: current,
    newRevisionId,
  });
  return {
    ...current,
    ...pointers,
    ...MutableEntity.Update({ cur: current, ...context }),
  };
};
